export default {
    palette: {
        maars: {
            dark: '#787371',
        }
    }
}
